module.exports = __webpack_public_path__ + "img/g0125.3bbd26ad.png";